/**
 * Copyright (c) 2024 Securisea, Inc.
 * All rights reserved.
 *
 * This is unpublished, propriety, internal
 * source code of Securisea, Inc.
 * No license is provided to any third parties.
 * If found outside of a Securisea, Inc. environment
 * report to bounty@securisea.com for a possible cash reward
 * and promptly delete all files.
 */
import React from "react";
import Layout from "../../layout";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { Box, Typography } from "@mui/material";
import OrgAdminUserTable from "../../components/tables/users/org_admin";
import { SlackNotificationManager } from "../../components/notifications/slack";
import { getUserInfo } from "../../helpers/user";

const OrgAdminUserPage = () => {
  const userInfo = getUserInfo();
  const organizationId = userInfo.organization_id;

  return (
    <Layout pageTitle="User Management" parentUrl="" parentPageName="">
      <Grid item xs={6}>
        <Card>
          <Box sx={{ mt: 0.2, textAlign: "end", backgroundColor: "grey.100" }}>
            <Typography sx={{ padding: "1rem", fontWeight: 700 }}>
              Users
            </Typography>
          </Box>
          <Box sx={{ mt: 0.2, m: 2 }}>
            <SlackNotificationManager organization_id={organizationId} />
          </Box>

          <OrgAdminUserTable />
        </Card>
      </Grid>
    </Layout>
  );
};

export default OrgAdminUserPage;
